<template lang="pug">
#other-user-template-complete
  // title
  .d-flex.flex-row.justify-content-center.mb-2
    .page-title 安否確認（施設関係者）の事前設定

  // progress
  ProcessIndicator(v-model="indicator")
  .mb-3.separator

  // message
  .mb-3 安否確認（施設関係者）の事前設定の更新が完了しました。

  // buttons
  .d-flex.flex-row.justify-content-center
    b-button.btn.back-btn(@click="onHome") ホームへ
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import ProcessIndicator, { ProcessIndicatorModel } from "@/mobile/basics/ProcessIndicator.vue";
import { MobileUrl } from "@/commons/constants/MobileUrl";

/**
 * ### 安否確認 事前設定(施設関係者) 完了コンポーネント
 */
@Component({
  components: {
    ProcessIndicator
  }
})
export default class OtherUserTemplateComplete extends Vue {
  /** インジケータ */
  indicator: Array<ProcessIndicatorModel> = [
    { text: "入力", current: false },
    { text: "確認", current: false },
    { text: "完了", current: true }
  ];

  /**
   * ### ホームへボタン押下イベント
   *
   * - ホーム画面へ遷移する
   */
  public onHome(): void {
    this.$router.push(MobileUrl.Home);
    return;
  }
}
</script>

<style lang="scss" scopeed>
#other-user-template-complete {
  .back-btn {
    min-width: 124px;
  }
}
</style>
